import {createReducer, on} from '@ngrx/store';
import {OrganizationActions} from './organization.actions';
import {ProductManagementErrorInterface} from '../../error/error-handling/product-management-error';

export const ORGANIZATION_FEATURE_KEY = 'organization';

export interface OrganizationState {
  organizationName: string | undefined;
  error: ProductManagementErrorInterface | undefined;
}

export const initialOrganizationState: OrganizationState = {
  organizationName: undefined,
  error: undefined,
};

export const organizationReducer = createReducer(
  initialOrganizationState,
  on(OrganizationActions.loadOrganizationName, (state: OrganizationState) => ({...state})),
  on(
    OrganizationActions.loadOrganizationNameSuccess,
    (state: OrganizationState, {organizationName}: {organizationName: string}) => ({
      ...state,
      organizationName: organizationName,
    })
  ),
  on(OrganizationActions.loadOrganizationNameFailure, (state: OrganizationState) => ({
    ...state,
    organizationName: undefined,
    error: {
      message: 'Error loading organization name, please refresh and try again.',
    } as ProductManagementErrorInterface,
  }))
);

export const getOrganizationName = (state: OrganizationState) => state.organizationName;
